import React from "react";
import MonthNavigator from "./MonthNavigator";
import SummaryStrip from "./SummaryStrip";
import AttendanceList from "./AttendanceList";
import { useAttendanceData } from "./useAttendanceData";
import {
    RefreshCw,
    ChevronLeft,
    ChevronRight,
    CheckCircle,
    Clock,
    AlertCircle,
} from "lucide-react";

export default function ShowEmployeeAttendance() {
    const {
        records,
        summary,
        loading,
        refreshing,
        error,
        monthName,
        year,
        isCurrentMonth,
        goToPrev,
        goToNext,
        refetch,
    } = useAttendanceData();

    return (
        <div className="max-w-4xl mx-auto px-3 sm:px-4 py-3 sm:py-6 bg-gray-50 min-h-screen">
            <div className="bg-white rounded-t-2xl px-4 sm:px-6 py-3 sm:py-4 flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 shadow-sm">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => window.history.back()}
                        className="p-1 hover:bg-yellow-300 rounded-full transition"
                    >
                        <ChevronLeft size={24} className="text-black" />
                    </button>
                    <h2 className="text-2xl font-bold text-black">
                     Attendance Data
                    </h2>
                </div>
              
            </div>
            {/* Month navigator */}
            <MonthNavigator
                monthName={monthName}
                year={year}
                isCurrentMonth={isCurrentMonth}
                onPrev={goToPrev}
                onNext={goToNext}
            />

            {/* Summary grid — only show when data is ready */}
            {!loading && !error && <SummaryStrip summary={summary} />}

            {/* Records count */}
            {!loading && !error && records.length > 0 && (
                <div className="px-5 py-2 bg-gray-50 flex-shrink-0">
                    <span className="text-[12px] font-bold text-gray-400 uppercase tracking-widest">
                        {records.length} Records
                    </span>
                </div>
            )}

            {/* List — handles all states internally */}
            <AttendanceList
                records={records}
                loading={loading}
                refreshing={refreshing}
                error={error}
                monthName={monthName}
                year={year}
                onRefresh={refetch}
            />
        </div>
    );
}
